import { EnvironmentProviders, InjectionToken, Provider } from '@angular/core';

export const ROLE_HIERARCHY = new InjectionToken<
  | {
      [index: string]: string | string[];
    }
  | {
      [index: string]: string | string[];
    }[]
>('tt-permission.roleHierarchy');

export function withRoleHierarchy(hierarchy: {
  [index: string]: string | string[];
}): (Provider | EnvironmentProviders)[] {
  return [
    {
      provide: ROLE_HIERARCHY,
      useValue: hierarchy,
      multi: true,
    },
  ];
}
